import * as ambassadorWixInnovationWidgetV1Message from './innovation-widget-v1-message-messages.http.js';
import * as ambassadorWixInnovationWidgetV1MessageTypes from './innovation-widget-v1-message-messages.types.js';
import * as ambassadorWixInnovationWidgetV1MessageUniversalTypes from './innovation-widget-v1-message-messages.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function bulkCreateMessages(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInnovationWidgetV1MessageUniversalTypes.BulkCreateMessagesRequest,
  ambassadorWixInnovationWidgetV1MessageTypes.BulkCreateMessagesRequest,
  ambassadorWixInnovationWidgetV1MessageUniversalTypes.BulkCreateMessagesResponse,
  ambassadorWixInnovationWidgetV1MessageTypes.BulkCreateMessagesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInnovationWidgetV1Message.bulkCreateMessages(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/messages/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listMessages(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixInnovationWidgetV1MessageUniversalTypes.ListMessagesRequest,
  ambassadorWixInnovationWidgetV1MessageTypes.ListMessagesRequest,
  ambassadorWixInnovationWidgetV1MessageUniversalTypes.ListMessagesResponse,
  ambassadorWixInnovationWidgetV1MessageTypes.ListMessagesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInnovationWidgetV1Message.listMessages(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/messages/list',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function mediaAttachmentUploadUrl(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixInnovationWidgetV1MessageUniversalTypes.MediaAttachmentUploadUrlRequest,
  ambassadorWixInnovationWidgetV1MessageTypes.MediaAttachmentUploadUrlRequest,
  ambassadorWixInnovationWidgetV1MessageUniversalTypes.MediaAttachmentUploadUrlResponse,
  ambassadorWixInnovationWidgetV1MessageTypes.MediaAttachmentUploadUrlResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInnovationWidgetV1Message.mediaAttachmentUploadUrl(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/messages/files/generate-upload-url',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkGetByInboxMessages(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixInnovationWidgetV1MessageUniversalTypes.BulkGetByInboxMessagesRequest,
  ambassadorWixInnovationWidgetV1MessageTypes.BulkGetByInboxMessagesRequest,
  ambassadorWixInnovationWidgetV1MessageUniversalTypes.BulkGetByInboxMessagesResponse,
  ambassadorWixInnovationWidgetV1MessageTypes.BulkGetByInboxMessagesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInnovationWidgetV1Message.bulkGetByInboxMessages(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/messages/get-by-inbox',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Message as MessageOriginal,
  Sender as SenderOriginal,
  SenderWithLiterals as SenderWithLiteralsOriginal,
  MessageType as MessageTypeOriginal,
  MessageTypeWithLiterals as MessageTypeWithLiteralsOriginal,
  Body as BodyOriginal,
  ChatHandler as ChatHandlerOriginal,
  ChatHandlerWithLiterals as ChatHandlerWithLiteralsOriginal,
  BulkCreateMessagesRequest as BulkCreateMessagesRequestOriginal,
  BulkCreateMessagesResponse as BulkCreateMessagesResponseOriginal,
  ListMessagesRequest as ListMessagesRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListMessagesResponse as ListMessagesResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  MediaAttachmentUploadUrlRequest as MediaAttachmentUploadUrlRequestOriginal,
  MediaAttachmentUploadUrlResponse as MediaAttachmentUploadUrlResponseOriginal,
  BulkGetByInboxMessagesRequest as BulkGetByInboxMessagesRequestOriginal,
  BulkGetByInboxMessagesResponse as BulkGetByInboxMessagesResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkGetByInboxMessagesResult as BulkGetByInboxMessagesResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  ScheduleCreateInsightsRequest as ScheduleCreateInsightsRequestOriginal,
  ScheduleCreateInsightsResponse as ScheduleCreateInsightsResponseOriginal,
  CancelCreateInsightsRequest as CancelCreateInsightsRequestOriginal,
  CancelCreateInsightsResponse as CancelCreateInsightsResponseOriginal,
  SetupRequest as SetupRequestOriginal,
  SetupResponse as SetupResponseOriginal,
  TeardownRequest as TeardownRequestOriginal,
  TeardownResponse as TeardownResponseOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  CommunicationsChannelsMessageReceived as CommunicationsChannelsMessageReceivedOriginal,
  VisitorMappedToContact as VisitorMappedToContactOriginal,
  AllocationResultType as AllocationResultTypeOriginal,
  AllocationResultTypeWithLiterals as AllocationResultTypeWithLiteralsOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './innovation-widget-v1-message-messages.types.js';
